import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Play from './pages/Play';
import GameWrapper from './components/GameWrapper';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms'; 
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import NotFound from './pages/NotFound';
import Calculator from './pages/Calculator';
import Market from './pages/Market';
import { useEffect } from 'react';
import { updateCanvasVars } from './utils/CanvasScaler';
import { NotificationProvider } from './contexts/NotificationContext';

function AppContent() {
  const location = useLocation();
  const loggedInUser = localStorage.getItem('loggedInUser');

  const isPlayPage = location.pathname === '/play';
  const isWalletPage = location.pathname.startsWith('/play/');
  const hideNavbar = (isWalletPage || isPlayPage) && loggedInUser;

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/play" element={<Play />} />
        <Route path="/play/:wallet" element={<GameWrapper />} /> 
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/calculator" element={<Calculator />} />
        <Route path="/market" element={<Market />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!hideNavbar && <Footer />}
    </>
  );
}

function App() {
  useEffect(() => {
    const update = () => {
      const canvas = document.querySelector('.game-canvas');
      if (canvas) updateCanvasVars(canvas);
    };

    update(); // ilk renderda ayarla
    window.addEventListener('resize', update);

    const canvas = document.querySelector('.game-canvas');
    const observer = new MutationObserver(update);
    if (canvas) observer.observe(canvas, { attributes: true });

    return () => {
      window.removeEventListener('resize', update);
      observer.disconnect();
    };
  }, []);

  
  return (
    <Router>
      <NotificationProvider>
        <AppContent />
      </NotificationProvider>
    </Router>
  );
}

export default App;
